import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';
import TuiSelect from '../common/base/Select';
import TuiOption from '../common/base/Option';
import { useI18n } from '../../locales';

interface Props {
  modelValue: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DurationTimePicker',
  props: {
    modelValue: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: number;
};

const { t } = useI18n();


const selectedTime = ref(props.modelValue);

const timeOptions = computed(() => {
  const options = [];
  // Add options for 15, 30, and 45 minutes
  for (let i = 15; i < 60; i += 15) {
    options.push({ value: i * 60, label: `${i} ${t('minutes')}` });
  }
  // Add options for 1 to 24 hours
  for (let i = 1; i < 24; i++) {
    options.push({ value: i * 60 * 60, label: `${i} ${t('hours')}` });
  }
  return options;
});

const updateTime = () => {
  emit('input', selectedTime.value);
};

watch(
  selectedTime,
  () => {
    updateTime();
  },
  {
    immediate: true,
  }
);
watch(
  () => props.modelValue,
  newValue => {
    selectedTime.value = newValue;
  },
  { immediate: true }
);

return { __sfc: true,t, props, emit, selectedTime, timeOptions, updateTime, TuiSelect, TuiOption }
}

})